import { useCallback, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useDimension } from 'hooks';
import { useEntityPickerType } from 'modules/campaigns/hooks/useEntityPickerType';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { COMPONENT_STATUS } from 'services/constants';

export const useEntityPickerStateManager = ({
    reset,
    reload,
    setSearchText,
    setStatus,
    moduleStatus,
    isModuleReady,
    disabled,
    debouncedSearchText,
    entities,
    entitiesFromStore,
    sortField,
    sortType,
}) => {
    const [selectedPickerType] = useEntityPickerType();
    const [selectedDimension] = useDimension();
    const { accountId: selectedAccountId } = useAccount();

    const reloadWrapper = useCallback(async () => {
        setStatus(COMPONENT_STATUS.LOADING);
        await reload();
        setStatus(COMPONENT_STATUS.ACTIVE);
    }, [setStatus, reload]);

    // clear state on selectedAccountId change
    useEffect(() => {
        reset();
        setSearchText('');
        setStatus(COMPONENT_STATUS.INITIAL);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAccountId, setStatus]);

    // Sync campaignStatus and component status
    useEffect(() => {
        setStatus(moduleStatus);
    }, [moduleStatus, setStatus]);

    useEffect(() => {
        if (!isModuleReady || disabled) {
            return;
        }

        reloadWrapper();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedSearchText,
        isModuleReady,
        disabled,
        sortField,
        sortType,
        selectedDimension,
        selectedPickerType,
        selectedAccountId,
    ]);

    useEffect(() => {
        if (isEmpty(entities) || !isEmpty(entitiesFromStore)) {
            return;
        }

        reset();
        reloadWrapper();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entitiesFromStore, entities]);

    return {
        reloadWrapper,
    };
};
